// Single source of truth for the four top-level categories of UNION Check.
// Keep this file lean — pages derive icons, routes and labels from here.

export const CATEGORIES = [
  {
    key: "scaffalatura",
    label: "Scaffalature",
    plural: "Scaffalature",
    singular: "Scaffalatura",
    icon: "scaffold",
    hubPath: "/scaffolds",
    detailPath: (id) => `/scaffolds/${id}`,
    collection: "scaffolds",    // backend list endpoint prefix
    kind: "scaffalatura",
    accent: "bg-[#0A0A0A] text-white",
  },
  {
    key: "dpi",
    label: "DPI",
    plural: "DPI",
    singular: "DPI",
    icon: "hardhat",
    hubPath: "/dpi",
    detailPath: (id) => `/devices/${id}`,
    collection: "devices",
    kind: "dpi",
    accent: "bg-[#FF5A00] text-white",
  },
  {
    key: "strumento",
    label: "Strumenti",
    plural: "Strumenti",
    singular: "Strumento",
    icon: "tool",
    hubPath: "/strumenti",
    detailPath: (id) => `/strumenti/${id}`,
    collection: "devices",
    kind: "strumento",
    accent: "bg-[#1E90FF] text-white",
  },
  {
    key: "lineavita",
    label: "Anticaduta",
    plural: "Anticaduta",
    singular: "Anticaduta",
    icon: "lifebuoy",
    hubPath: "/anticaduta",
    detailPath: (id) => `/anticaduta/${id}`,
    collection: "scaffolds",
    kind: "lineavita",
    accent: "bg-[#10B981] text-white",
  },
];

export const CATEGORY_BY_KEY = Object.fromEntries(CATEGORIES.map((c) => [c.key, c]));

// Sub-category options for each top-level kind.
export const TOOL_SUBCATEGORIES = [
  { value: "scale", label: "Scale" },
  { value: "strumenti_di_misura", label: "Strumenti di Misura" },
  { value: "estintori", label: "Estintori" },
  { value: "altro", label: "Altro" },
];

export const DPI_SUBCATEGORIES = [
  { value: "casco", label: "Casco" },
  { value: "imbracatura", label: "Imbracatura" },
  { value: "cordino", label: "Cordino" },
  { value: "cassetta_primo_soccorso", label: "Cassetta Primo Soccorso" },
  { value: "fettuccia", label: "Fettuccia" },
  { value: "arrotolatore", label: "Arrotolatore" },
  { value: "moschettone", label: "Moschettone" },
  { value: "altro", label: "Altro" },
];

export function welcomeMessage(now = new Date()) {
  const h = now.getHours();
  if (h >= 8 && h < 12) return "Buongiornissimo, check rapido? ☕✅";
  if (h >= 12 && h < 14) return "La Sicurezza non va in pausa pranzo, eh? 🍕⛑️";
  if (h >= 14 && h < 18) return "La precisione fa la differenza tra un lavoro fatto e uno fatto bene 🔎💪";
  return "La Sicurezza non dorme mai 🌙🛡️";
}
